import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const QuoteForm = ({ onSubmit, assessmentData = null }) => {
  const [formData, setFormData] = useState({
    projectType: '',
    urgency: '',
    companyName: '',
    contactName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    currentInfrastructure: '',
    buildingSize: '',
    employeeCount: '',
    specificRequirements: '',
    preferredContactTime: '',
    hasExistingAssessment: false,
    agreedToTerms: false
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Pre-populate from assessment data if available
  useEffect(() => {
    if (assessmentData) {
      setFormData(prev => ({
        ...prev,
        companyName: assessmentData?.companyName || '',
        currentInfrastructure: assessmentData?.currentSetup || '',
        buildingSize: assessmentData?.buildingSize || '',
        employeeCount: assessmentData?.employeeCount || '',
        hasExistingAssessment: true
      }));
    }
  }, [assessmentData]);

  const projectTypeOptions = [
    { value: 'emergency', label: 'Emergency Connectivity Issues', description: 'Immediate resolution needed' },
    { value: 'planned-upgrade', label: 'Planned Infrastructure Upgrade', description: 'Scheduled improvement project' },
    { value: 'new-construction', label: 'New Construction Support', description: 'Building new infrastructure' },
    { value: 'performance-optimization', label: 'Performance Optimization', description: 'Enhance existing systems' }
  ];

  const urgencyOptions = [
    { value: 'immediate', label: 'Immediate (24-48 hours)' },
    { value: 'urgent', label: 'Urgent (1 week)' },
    { value: 'standard', label: 'Standard (2-4 weeks)' },
    { value: 'planned', label: 'Planned (1-3 months)' }
  ];

  const stateOptions = [
    { value: 'CA', label: 'California' },
    { value: 'TX', label: 'Texas' },
    { value: 'FL', label: 'Florida' },
    { value: 'NY', label: 'New York' },
    { value: 'IL', label: 'Illinois' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'OH', label: 'Ohio' },
    { value: 'GA', label: 'Georgia' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'MI', label: 'Michigan' }
  ];

  const infrastructureOptions = [
    { value: 'copper-only', label: 'Copper Only' },
    { value: 'mixed-copper-fiber', label: 'Mixed Copper/Fiber' },
    { value: 'legacy-fiber', label: 'Legacy Fiber (needs upgrade)' },
    { value: 'no-infrastructure', label: 'No existing infrastructure' }
  ];

  const buildingSizeOptions = [
    { value: 'small', label: 'Small (< 5,000 sq ft)' },
    { value: 'medium', label: 'Medium (5,000 - 25,000 sq ft)' },
    { value: 'large', label: 'Large (25,000 - 100,000 sq ft)' },
    { value: 'enterprise', label: 'Enterprise (> 100,000 sq ft)' }
  ];

  const employeeCountOptions = [
    { value: '1-10', label: '1-10 employees' },
    { value: '11-50', label: '11-50 employees' },
    { value: '51-200', label: '51-200 employees' },
    { value: '201-500', label: '201-500 employees' },
    { value: '500+', label: '500+ employees' }
  ];

  const contactTimeOptions = [
    { value: 'morning', label: 'Morning (8 AM - 12 PM)' },
    { value: 'afternoon', label: 'Afternoon (12 PM - 5 PM)' },
    { value: 'evening', label: 'Evening (5 PM - 8 PM)' },
    { value: 'anytime', label: 'Anytime during business hours' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors?.[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateStep = (step) => {
    const newErrors = {};

    if (step === 1) {
      if (!formData?.projectType) newErrors.projectType = 'Please select a project type';
      if (!formData?.urgency) newErrors.urgency = 'Please select urgency level';
    }

    if (step === 2) {
      if (!formData?.companyName) newErrors.companyName = 'Company name is required';
      if (!formData?.contactName) newErrors.contactName = 'Contact name is required';
      if (!formData?.email) newErrors.email = 'Email is required';
      if (!formData?.phone) newErrors.phone = 'Phone number is required';
    }

    if (step === 3) {
      if (!formData?.address) newErrors.address = 'Address is required';
      if (!formData?.city) newErrors.city = 'City is required';
      if (!formData?.state) newErrors.state = 'State is required';
      if (!formData?.zipCode) newErrors.zipCode = 'ZIP code is required';
    }

    if (step === 4) {
      if (!formData?.currentInfrastructure) newErrors.currentInfrastructure = 'Please select current infrastructure';
      if (!formData?.buildingSize) newErrors.buildingSize = 'Please select building size';
      if (!formData?.employeeCount) newErrors.employeeCount = 'Please select employee count';
      if (!formData?.agreedToTerms) newErrors.agreedToTerms = 'You must agree to the terms';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    setCurrentStep(prev => prev - 1);
  };

  const handleSubmit = async (e) => {debugger;
    e?.preventDefault();

  const formType =  "Get Quote" ;

  const data = new FormData();
debugger;
  if (formType === "Get Quote") {
    data.append("formType", "Get Quote");
    data.append("projectType", formData.projectType);
    data.append("urgency", formData.urgency);
    data.append("company", formData.companyName);
    data.append("name", formData.contactName);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("address", formData.address);
    data.append("city", formData.city);
    data.append("state", formData.state);
    data.append("zipCode", formData.zipCode);
    data.append("currentInfrastructure", formData.currentInfrastructure);
    data.append("buildingSize", formData.buildingSize);
    data.append("employeeCount", formData.employeeCount);
    data.append("specificRequirements", formData.specificRequirements);
  }

  if (formType === "Schedule Consultation") {
    data.append("formType", "Schedule Consultation");
    data.append("name", contactForm.name);
    data.append("email", contactForm.email);
    data.append("phone", contactForm.phone);
    data.append("date", scheduleData.date);
    data.append("time", scheduleData.time);
    data.append("team", scheduleData.team);
    data.append("message", contactForm.message);
  }

  try {
    const response = await fetch("/send-mail.php", {
      method: "POST",
      body: data,
    });

    const result = await response.text();
    if (result === "success") {
      alert("Email Sent Successfully.");
    } else {
      alert("Failed to send email. Please try again.");
    }
  } catch (err) {
    console.error("Error:", err);
    alert("Something went wrong.");
  }

    if (!validateStep(4)) return;

    setIsSubmitting(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      onSubmit(formData);
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderStepIndicator = () => (
    <div className="flex items-center justify-center mb-8">
      {[1, 2, 3, 4]?.map((step) => (
        <React.Fragment key={step}>
          <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium transition-all duration-200 ${
            step <= currentStep 
              ? 'bg-primary text-white' :'bg-muted text-text-secondary'
          }`}>
            {step < currentStep ? (
              <Icon name="Check" size={16} />
            ) : (
              step
            )}
          </div>
          {step < 4 && (
            <div className={`w-12 h-0.5 mx-2 transition-all duration-200 ${
              step < currentStep ? 'bg-primary' : 'bg-border'
            }`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );

  const renderStep1 = () => (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-text-primary mb-2">Project Details</h3>
        <p className="text-text-secondary">Tell us about your project requirements</p>
      </div>

      <Select
        label="Project Type"
        description="What type of project do you need help with?"
        options={projectTypeOptions}
        value={formData?.projectType}
        onChange={(value) => handleInputChange('projectType', value)}
        error={errors?.projectType}
        required
      />

      <Select
        label="Urgency Level"
        description="When do you need this project completed?"
        options={urgencyOptions}
        value={formData?.urgency}
        onChange={(value) => handleInputChange('urgency', value)}
        error={errors?.urgency}
        required
      />

      {formData?.projectType === 'emergency' && (
        <div className="p-4 bg-error/10 border border-error/20 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="AlertTriangle" size={20} className="text-error mt-0.5" />
            <div>
              <h4 className="font-medium text-error mb-1">Emergency Support Available</h4>
              <p className="text-sm text-text-secondary">
                For immediate assistance, call our 24/7 emergency line: <strong>(555) 911-FIBER</strong>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const renderStep2 = () => (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-text-primary mb-2">Contact Information</h3>
        <p className="text-text-secondary">How can we reach you?</p>
      </div>

      <Input
        label="Company Name"
        type="text"
        placeholder="Enter your company name"
        value={formData?.companyName}
        onChange={(e) => handleInputChange('companyName', e?.target?.value)}
        error={errors?.companyName}
        required
      />

      <Input
        label="Contact Name"
        type="text"
        placeholder="Enter your full name"
        value={formData?.contactName}
        onChange={(e) => handleInputChange('contactName', e?.target?.value)}
        error={errors?.contactName}
        required
      />

      <Input
        label="Email Address"
        type="email"
        placeholder="Enter your email address"
        value={formData?.email}
        onChange={(e) => handleInputChange('email', e?.target?.value)}
        error={errors?.email}
        required
      />

      <Input
        label="Phone Number"
        type="tel"
        placeholder="Enter your phone number"
        value={formData?.phone}
        onChange={(e) => handleInputChange('phone', e?.target?.value)}
        error={errors?.phone}
        required
      />

      <Select
        label="Preferred Contact Time"
        description="When is the best time to reach you?"
        options={contactTimeOptions}
        value={formData?.preferredContactTime}
        onChange={(value) => handleInputChange('preferredContactTime', value)}
      />
    </div>
  );

  const renderStep3 = () => (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-text-primary mb-2">Project Location</h3>
        <p className="text-text-secondary">Where is your project located?</p>
      </div>

      <Input
        label="Street Address"
        type="text"
        placeholder="Enter street address"
        value={formData?.address}
        onChange={(e) => handleInputChange('address', e?.target?.value)}
        error={errors?.address}
        required
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="City"
          type="text"
          placeholder="Enter city"
          value={formData?.city}
          onChange={(e) => handleInputChange('city', e?.target?.value)}
          error={errors?.city}
          required
        />

        <Select
          label="State"
          options={stateOptions}
          value={formData?.state}
          onChange={(value) => handleInputChange('state', value)}
          error={errors?.state}
          required
        />
      </div>

      <Input
        label="ZIP Code"
        type="text"
        placeholder="Enter ZIP code"
        value={formData?.zipCode}
        onChange={(e) => handleInputChange('zipCode', e?.target?.value)}
        error={errors?.zipCode}
        required
      />
    </div>
  );

  const renderStep4 = () => (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-text-primary mb-2">Technical Requirements</h3>
        <p className="text-text-secondary">Help us understand your current setup</p>
      </div>

      <Select
        label="Current Infrastructure"
        description="What type of network infrastructure do you currently have?"
        options={infrastructureOptions}
        value={formData?.currentInfrastructure}
        onChange={(value) => handleInputChange('currentInfrastructure', value)}
        error={errors?.currentInfrastructure}
        required
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Building Size"
          options={buildingSizeOptions}
          value={formData?.buildingSize}
          onChange={(value) => handleInputChange('buildingSize', value)}
          error={errors?.buildingSize}
          required
        />

        <Select
          label="Employee Count"
          options={employeeCountOptions}
          value={formData?.employeeCount}
          onChange={(value) => handleInputChange('employeeCount', value)}
          error={errors?.employeeCount}
          required
        />
      </div>

      <Input
        label="Specific Requirements"
        type="text"
        placeholder="Any specific requirements or concerns? (Optional)"
        value={formData?.specificRequirements}
        onChange={(e) => handleInputChange('specificRequirements', e?.target?.value)}
      />

      {assessmentData && (
        <div className="p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="CheckCircle" size={20} className="text-accent mt-0.5" />
            <div>
              <h4 className="font-medium text-accent mb-1">Assessment Data Available</h4>
              <p className="text-sm text-text-secondary">
                We've pre-filled some information from your network assessment. Our team will review this during consultation.
              </p>
            </div>
          </div>
        </div>
      )}

      <Checkbox
        label="I agree to the terms and conditions"
        description="By checking this box, you agree to our consultation terms and privacy policy"
        checked={formData?.agreedToTerms}
        onChange={(e) => handleInputChange('agreedToTerms', e?.target?.checked)}
        error={errors?.agreedToTerms}
        required
      />
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="space-y-8">
        {renderStepIndicator()}
        
        <div className="bg-white rounded-lg shadow-brand-moderate p-6 md:p-8">
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
          {currentStep === 4 && renderStep4()}
        </div>

        <div className="flex justify-between">
          <Button
            type="button"
            variant="outline"
            onClick={handlePrevious}
            disabled={currentStep === 1}
            iconName="ChevronLeft"
            iconPosition="left"
          >
            Previous
          </Button>

          {currentStep < 4 ? (
            <Button
              type="button"
              variant="default"
              onClick={handleNext}
              iconName="ChevronRight"
              iconPosition="right"
            >
              Next
            </Button>
          ) : (
            <Button
              type="submit"
              variant="default"
              loading={isSubmitting}
              iconName="Send"
              iconPosition="left"
              className="cta-primary"
            >
              {isSubmitting ? 'Submitting...' : 'Submit Request'}
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default QuoteForm;